import { Injectable } from '@angular/core';
import {
  AbstractControlOptions,
  UntypedFormArray,
  Validators,
} from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { SavingsRate } from '@app/forms/subscription/definition/interface/subscription';
import { FormConfig } from '@app/forms/subscription/definition/types/subscription';
import FormGroupArray from '../../services/FormGroupArray';
@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generateForm(entity: SavingsRate & { riskProfil: any }) {
    let options: AbstractControlOptions = {};
    const q21FormConfig: FormConfig<SavingsRate & { riskProfil: any }> = {
      ownerId: [entity.ownerId],
      userFirstName: [entity.userFirstName],
      userLastName: [entity.userLastName],

      // savingsRate: [entity?.savingsRate || null, Validators.required],
      riskProfil: this.formBuilder.group({
        savingsRate: [
          entity?.riskProfil?.savingsRate || null,
          Validators.required,
        ],
      }),
    };

    return this.formBuilder.group(q21FormConfig, options);
  }
  generate(entity: SavingsRate[], option) {
    return FormGroupArray.generate({
      entity,
      options: option,
      formBuilder: this.formBuilder,
      generateForm: this.generateForm.bind(this),
    });
  }
  get owners() {
    return this.form.get('owners') as UntypedFormArray;
  }

  extract() {
    return this.form.value.owners;
  }
}
